import React from 'react';
import DesktopProfileTop728x90Gak from './gak/DesktopProfileTop728x90';
const DesktopProfileTop728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopProfileTop728x90Gak, {
        safety: safety
    });
};
DesktopProfileTop728x90.displayName = 'DesktopProfileTop728x90';
export default DesktopProfileTop728x90;
